import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import ActionForm from '~/components/ActionForm';
import { useComponentFetcher } from '~/components/ComponentErrorBoundary/useComponentFetcher';
import StatusInputs from '~/components/Forms/StatusInputs';
import toast from '~/utils/toast';

type Props = {
  children: ({ isLoading }: { isLoading: boolean }) => ReactNode;
  onSuccess?: () => void;
};

const ResetPasswordAction = ({ children, onSuccess }: Props) => {
  const { t } = useTranslation();
  const fetcher = useComponentFetcher();
  const isLoading = fetcher.state === 'submitting';

  return (
    <ActionForm
      fetcher={fetcher}
      method="post"
      action={'/change_password'}
      onSuccess={(data: any) => {
        onSuccess?.();
        if (data?.toast?.message) {
          toast.success(data.toast.message);
        }
      }}
      onError={(data: any) => {
        toast.error(data?.toast?.message || 'Something went wrong, please try again');
      }}
    >
      <StatusInputs name="password" successMessage={t('toast.success')} errorMessage={t('toast.error')} />
      {children({ isLoading })}
    </ActionForm>
  );
};

export default ResetPasswordAction;
